export default __webpack_public_path__ + "static/media/withoutrecipes.62e5e039.png";